<template>
    <div>
      <div class="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>首页</el-breadcrumb-item>
          <el-breadcrumb-item>外文官网</el-breadcrumb-item>
          <el-breadcrumb-item>Banner管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="operating">
        <span> <el-button type="primary" size="small" @click="addDialog" >新增</el-button></span>
      </div>
      <div>
        <template>
          <el-table
            :data="tableData"
            stripe
            center
            border
            highlight-current-row
            style="width: 100%">
            <el-table-column
              align="center"
              label="排序"
              width="80"
              prop="sequence">
              <template slot-scope="scope">
                <el-input  size="small" v-model="scope.row.sequence" @change="changeSort(scope.row)"></el-input>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              label="所属官网"
              :formatter="languageFormatter"
              prop="language">
            </el-table-column>
            <el-table-column
              align="center"
              label="所属游戏"
              prop="game.name">
            </el-table-column>
            <el-table-column
              align="center"
              label="平台"
              :formatter="platformFormatter"
              prop="platform">
            </el-table-column>
            <el-table-column
              align="center"
              label="位置"
              prop="position"
              :formatter="positionFormatter">
            </el-table-column>
            <el-table-column
              align="center"
              label="标题"
              prop="title">
            </el-table-column>
            <el-table-column
              align="center"
              label="预览图">
              <template slot-scope="scope">
                <el-image :src="scope.row.file.file_path" :preview-src-list="[scope.row.file.file_path]" alt="" style="height: 40px">
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              label="是否可见"
              prop="is_visible">
              <template slot-scope="scope">
                <el-tooltip :content="scope.row.is_visible?'可见':'不可见'" placement="top">
                  <el-switch
                    v-model="scope.row.is_visible"
                    @change="handleChangeStatus(scope.row)"
                    active-color="#13ce66"
                    inactive-color="#DCDFE6">
                  </el-switch>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              label="操作"
              width="140">
              <template slot-scope="scope" >
                <el-button
                  type="primary"
                  size="small"
                  @click="editDialog(scope.row)">编辑
                </el-button>
                <el-popconfirm
                  confirmButtonText='确定'
                  cancelButtonText='返回'
                  icon="el-icon-info"
                  iconColor="red"
                  title="删除不可恢复，确定删除吗？"
                  @onConfirm="del(scope.row.id)"
                >
                  <el-button type="primary"  size="small" slot="reference">删除</el-button>
                </el-popconfirm>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </div>
      <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" @opened="openHandle"  @close="callOf" :close-on-click-modal="false" width="600px" class="padding_10">
        <el-form :model="form"  :rules="rules" label-width="120px"  ref="form">
          <el-form-item label="banner标题" prop="title" >
            <el-input v-model="form.title" auto-complete="off" placeholder="请输入banner标题"></el-input>
          </el-form-item>
          <el-form-item label="所属官网" prop="language" >
            <el-select v-model="form.language" @change="setGames" placeholder="请选择" style="width: 100%">
              <el-option
                v-for="item in language"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属游戏" prop="game_id" :rules="gameRule">
            <el-select v-model="form.game_id" placeholder="请选择" style="width: 100%">
              <el-option
                v-for="item in games"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="平台" prop="platform" >
            <el-select v-model="form.platform" placeholder="请选择" style="width: 100%">
              <el-option
                v-for="item in platform"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="位置" prop="position" >
            <el-select v-model="form.position" placeholder="请选择" style="width: 100%">
              <el-option
                v-for="item in position"
                :key="item.id"
                :label="item.value"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="icon" prop="icon_id" >
            <el-upload
              v-loading="uploadLoading"
              action="#"
              list-type="picture-card"
              :before-upload="beforeUpload"
              :on-change="handleChange"
              :http-request="submitUpload"
              accept=".jpg,.png,.jpeg"
              :show-file-list="false"
              ref="icon">
              <img  v-if="form.icon_img" :src="form.icon_img"   style="width: 146px!important;height: 146px;">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="图片" prop="file_id">
            <el-upload
              v-loading="uploadFileLoading"
              action="#"
              :on-change="handleChange"
              :before-upload="beforeUpload"
              :http-request="uploadImg"
              list-type="picture"
              :file-list="fileList"
              :on-remove="handleRemove"
              ref="upload"
              :limit="1"
              drag
              accept=".jpg,.png,.jpeg"
              prop="file_id">
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
              <div slot="tip" style="color: red;font-size: 14px;margin-left: 8px" class="el-upload__tip">
                英文官网: 移动端750*1345 韩文官网：PC 1106*878  移动端750*1492
              </div>
            </el-upload>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" size="small" :loading="loading" @click="store">保 存</el-button>
          <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
</template>

<script>
import {uploadImg} from '../../../api'
import {bannerAll, bannerChange, bannerDelete, bannerStore} from '../../../api/language/banner'
import {getShelvesGame} from '../../../api/language/game'

export default {
  data () {
    return {
      item: {},
      loading: false,
      uploadLoading: false,
      uploadFileLoading: false,
      tableData: [],
      platform: [
        {
          value: 1,
          label: 'PC'
        },
        {
          value: 2,
          label: 'Mobile'
        }
      ],
      language: [
        {
          value: 1,
          label: '英文官网'
        },
        {
          value: 2,
          label: '韩文官网'
        },
        {
          value: 3,
          label: '荷米斯英文'
        },
        {
          value: 4,
          label: '海南搜易'
        }
      ],
      dialogTitle: '',
      dialogVisible: false,
      form: {
        title: '',
        position: 1,
        game_id: '',
        platform: '',
        language: '',
        file_id: '',
        icon_id: '',
        icon_img: ''
      },
      rules: {
        file_id: [
          { required: true, message: '请上传图片', trigger: 'change' }
        ],
        icon_id: [
          { required: true, message: '请上传icon', trigger: 'change' }
        ],
        language: [
          { required: true, message: '请选择所属官网', trigger: 'change' }
        ],
        position: [
          { required: true, message: '请选择位置', trigger: 'change' }
        ],
        platform: [
          { required: true, message: '请选择平台', trigger: 'change' }
        ],
        title: [
          { required: true, message: '请输入标题', trigger: 'blur' }
        ]
      },
      gameRule: [],
      position: [
        {id: 1, value: '首页头部'}
        // {id: 2, value: '旗下游戏'},
        // {id: 3, value: '公司介绍'},
        // {id: 4, value: '人才招聘'},
        // {id: 5, value: '商务合作'},
        // {id: 6, value: '企业资讯'}
      ],
      games: [],
      fileList: [],
      file: {}
    }
  },
  mounted () {
    // 页面数据初始化表格数据
    this.setTableData()
  },
  methods: {
    store () {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.loading = true
          bannerStore(this.form).then(res => {
            if (res.status === 2000) {
              this.setTableData()
              this.dialogVisible = false
            }
            this.$notify({
              message: res.message,
              type: res.status === 2000 ? 'success' : 'warning',
              offset: 100,
              showClose: false
            })
            this.loading = false
          })
        }
      })
    },
    setGames (language) {
      if (!language) {
        return
      }
      this.$set(this.form, 'game_id', '')
      getShelvesGame({language: language}).then(res => {
        if (res.status === 2000) {
          this.games = res.data
        } else {
          this.games = []
        }
        if (this.games.length > 0) {
          this.gameRule = [
            { required: true, message: '请选择游戏', trigger: 'change' }
          ]
        } else {
          this.gameRule = []
        }
      })
    },
    languageFormatter (row, column, cellValue, index) {
      let l = this.language.find(item => item.value === cellValue)
      return l ? l.label : '-'
    },
    platformFormatter (row, column, cellValue, index) {
      let pf = this.platform.find(item => item.value === cellValue)
      return pf ? pf.label : '-'
    },
    positionFormatter (row, column, cellValue, index) {
      let pf = this.position.find(item => item.id === cellValue)
      return pf ? pf.value : '-'
    },
    // 數據表格渲染
    setTableData () {
      let data = {
        page: this.page,
        page_size: this.page_size,
        order: this.order_column,
        order_mode: this.order_mode
      }
      bannerAll(data).then(res => {
        let {status} = res
        if (status === 2000) {
          this.tableData = res.data
        } else {
          this.tableData = []
        }
      })
    },
    // 更改状态
    handleChangeStatus (row) {
      this.changeStore({
        banner_id: row.id,
        is_visible: row.is_visible
      })
    },
    // 更新制定字段
    changeStore (data) {
      bannerChange(data).then(res => {
        let {status, message} = res
        this.$notify({
          message: message,
          type: status === 2000 ? 'success' : 'warning',
          offset: 100,
          showClose: false
        })
        this.setTableData()
      })
    },
    // 更改排序
    changeSort (row) {
      this.changeStore({
        banner_id: row.id,
        sequence: row.sequence
      })
    },
    // 刪除banner
    del (id) {
      bannerDelete({
        banner_id: id
      }).then(res => {
        let {status, message} = res
        this.$notify({
          message: message,
          type: status === 2000 ? 'success' : 'warning',
          offset: 100,
          showClose: false
        })
        if (status === 2000) {
          this.setTableData()
        }
      })
    },
    // 上传前回调
    beforeUpload (file) {
      const isImg = ['image/jpeg', 'image/png', 'image/jpg'].indexOf(file.type) >= 0
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isImg) {
        this.$notify({
          message: '上传图片必须为jpg或png 格式!',
          type: 'warning',
          offset: 100,
          showClose: false
        })
      }
      if (!isLt2M) {
        this.$notify({
          message: '上传图片大小不能超过 2MB!',
          type: 'warning',
          offset: 100,
          showClose: false
        })
      }
      return isImg && isLt2M
    },
    // 上传文件，获取文件流
    handleChange (file) {
      this.file = file.raw
    },
    // 文件上传
    uploadImg () {
      this.uploadFileLoading = true
      this.$refs.upload.clearFiles()
      // 创建表单对象
      let form = new FormData()
      // 后端接受参数 ，可以接受多个参数
      form.append('file', this.file)
      uploadImg(form).then(res => {
        let {status, message} = res
        if (status === 2000) {
          this.form.file_id = res.data.file_id
          this.fileList = [{
            name: res.data.file_name,
            url: res.data.file_path
          }]
          this.file = {}
        }
        this.$notify({
          message: message,
          type: status === 2000 ? 'success' : 'warning',
          offset: 100,
          showClose: false
        })
        this.uploadFileLoading = false
      })
    },
    // icon 上传
    submitUpload () {
      this.uploadLoading = true
      this.$refs.icon.clearFiles()
      // 创建表单对象
      let form = new FormData()
      // 后端接受参数 ，可以接受多个参数
      form.append('file', this.file)
      uploadImg(form).then(res => {
        let {status, message} = res
        if (status === 2000) {
          this.form.icon_id = res.data.file_id
          this.form.icon_img = res.data.file_path
          this.file = {}
        }
        this.$notify({
          message: message,
          type: status === 2000 ? 'success' : 'warning',
          offset: 100,
          showClose: false
        })
        this.uploadLoading = false
        this.$refs.icon.clearFiles()
      })
    },
    // 文件删除回调
    handleRemove () {
      this.form.file_id = ''
      this.fileList = []
    },
    // 关闭弹窗
    callOf () {
      this.fileList = []
      this.file = {}
      this.item = {}
      this.dialogTitle = ''
      this.form.icon_img = ''
      this.$refs['form'].resetFields()
    },
    openHandle () {
      if (this.item) {
        this.form = this.item
        this.setGames(this.form.game_id)
      }
    },
    // 新增弹窗
    addDialog () {
      this.dialogVisible = true
      this.dialogTitle = '新增Banner'
    },
    // 编辑弹窗
    editDialog (row) {
      this.dialogVisible = true
      this.dialogTitle = '编辑Banner'
      this.fileList = []
      this.item = {
        id: row.id,
        title: row.title,
        game_id: row.game_id === 0 ? '' : row.game_id,
        position: row.position,
        platform: row.platform,
        language: row.language,
        file_id: row.file_id,
        icon_id: row.icon_id,
        icon_img: row.icon.file_path
      }
      this.fileList = [{name: row.file.filename, url: row.file.file_path}]
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/language/banner/index.vue